__turbopack_context__.v({
  "animated": "BzqAMq_animated",
  "hat": "BzqAMq_hat",
  "show": "BzqAMq_show",
  "showWord": "BzqAMq_showWord",
  "title": "BzqAMq_title",
  "withAnimation": "BzqAMq_withAnimation",
  "word": "BzqAMq_word",
});
